import { StyledCartoonBox } from './CartoonBox.styled';
import Image from 'next/image';
import { AnimatePresence } from 'framer-motion';

export default function CartoonBox({ box, src }) {
  return (
    <AnimatePresence>
      <StyledCartoonBox
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div
          className="box-masked-image"
          key={box.id}
          style={{
            position: 'absolute',
            width: '100%',
          }}
        >
          <Image
            src={src}
            layout={'fill'}
            alt=""
            style={{
              clipPath: `polygon(${pathPointsToCssPolygon(box.points)})`,
            }}
          />
        </div>
      </StyledCartoonBox>
    </AnimatePresence>
  );
}

function pathPointsToCssPolygon(points) {
  const cssPoly = points.reduce(
    (cssPolyString, point) =>
      cssPolyString
        ? `${cssPolyString}, ${point[0].toFixed(2)}% ${point[1].toFixed(2)}%`
        : `${point[0].toFixed(2)}% ${point[1].toFixed(2)}%`,
    null
  );

  return cssPoly;
}
